import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import apiService from './api.service';
export var UrlList = {
  userManagementUrls: {
    userListUrl: '/api/organizations/users/attachedinfo/${Size}/${Index}?orderBy=${orderBy}&orderDirection=${orderDirection}&terms=${terms}',
    getSFxRoles: '/api/sfx/roles',
    getSolutionList: '/api/organizations/solutions/account',
    createUser: '/api/users/solutionuser/batch',
    updateUser: '/api/users/solutionuser',
    deleteUser: '/api/users/solutionuser/${email}',
    validateEmail: '/api/users/check/email/${email}',
    validateGenericEmail: '/api/users/check/generic_email/${email}',
    validatePassword: '/api/users/identity',
    getUserAssignedSolutions: '/api/user/assignedsolutions',
    validInviteUserEmail: '/api/user/self/invite/${email}/${status}',
    inviteUser: '/api/user/self/invite',
    checkAnswerUrl: '/api/user/answers/check',
    getUserRequest: '/api/user/self/invite/review',
    refreshUserRequest: '/api/user/self/invite/refresh',
    approveUserRequest: '/api/user/self/invite/approve',
    rejectUserRequest: '/api/user/self/invite/deny'
  },
  plantManagementUrls: {
    getSubscriptionKey: '/api/map',
    getPlant: '/api/Account/Plant',
    addPlant: '/api/Account/Plant',
    updatePlant: '/api/Account/Plant',
    deletePlant: '/api/Account/Plant/${ObjectID}'
  },
  solutionUrls: {
    getSolutionsAttachedInfo: '/api/organizations/solutions/account/attachedinfo',
    getSolutions: '/api/organizations/solutions/account/',
    getSolutionUsers: '/api/solutions/${solutionId}/users/account/${pageSize}/${pageIndex}?orderBy=${orderBy}&orderDirection=${orderDirection}',
    getSolutionNoAccessUsers: '/api/solutions/${solutionId}/users/account/noaccess',
    assignUserToSolution: '/api/users/solutionuser/solution/assign',
    removeUserFromSolution: '/api/users/solutionuser/solution/remove',
    updateUserFromSolution: '/api/users/solutionuser/solution/update',
    getUserSolutions: '/api/user/solutions'
  },
  subscriptionUrls: {
    getSubscriptions: '/api/solutions/${solutionId}/subscriptions/account/${pageSize}/${pageIndex}?orderBy=${orderBy}&orderDirection=${orderDirection}',
    getAllAssets: '/api/Assets/PaginateLite',
    assignSubscription: '/api/Licenses',
    validateVoucherCode: '/api/Licenses/voucher/check/${voucherCode}',
    useVoucherCode: '/api/Licenses/voucher/consume/${voucherCode}'
  },
  overrideBaseURL: ''
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export var replaceParamVal = function replaceParamVal(url, params) {
  var exp = /\$\{(.*?)\}/;
  var result = exp.exec(url);
  var newUrl = url;

  if (exp.test(newUrl)) {
    if (result && result[0]) {
      newUrl = newUrl.replace(result[0], params[result[1]]);
      return replaceParamVal(newUrl, params);
    }
  }

  return newUrl;
};
export var initAccountSettingApi = function initAccountSettingApi(obj) {
  var userManagementUrls = obj.userManagementUrls,
      solutionUrls = obj.solutionUrls,
      plantManagementUrls = obj.plantManagementUrls,
      subscriptionUrls = obj.subscriptionUrls,
      AuthorityUrl = obj.AuthorityUrl;

  if (userManagementUrls) {
    UrlList.userManagementUrls = _objectSpread(_objectSpread({}, UrlList.userManagementUrls), userManagementUrls);
    UrlList.solutionUrls = _objectSpread(_objectSpread({}, UrlList.solutionUrls), solutionUrls);
    UrlList.plantManagementUrls = _objectSpread(_objectSpread({}, UrlList.plantManagementUrls), plantManagementUrls);
    UrlList.subscriptionUrls = _objectSpread(_objectSpread({}, UrlList.subscriptionUrls), subscriptionUrls);
  }

  if (AuthorityUrl) {
    UrlList.overrideBaseURL = AuthorityUrl;
  }
};
export var getUserList = function getUserList(param) {
  var url = replaceParamVal(UrlList.userManagementUrls.userListUrl, param);
  return apiService.get(url, {}, {
    catchError: true
  });
};
export var getSolutionListApi = function getSolutionListApi() {
  return apiService.get(UrlList.userManagementUrls.getSolutionList, {}, {
    catchError: true
  });
};
export var getSFxRolesApi = function getSFxRolesApi() {
  return apiService.get(UrlList.userManagementUrls.getSFxRoles, {}, {
    catchError: true
  });
};
export var createUserApi = function createUserApi(data) {
  return apiService.post(UrlList.userManagementUrls.createUser, data, {
    catchError: true
  });
};
export var updateUserApi = function updateUserApi(data, opts) {
  return apiService.put(UrlList.userManagementUrls.updateUser, data, opts);
};
export var deleteUserApi = function deleteUserApi(email, opts) {
  var url = replaceParamVal(UrlList.userManagementUrls.deleteUser, {
    email: email
  });
  return apiService.delete(url, email, opts);
};
export var validateEmailApi = function validateEmailApi(email, opts) {
  var overrideBaseURL = UrlList.overrideBaseURL;
  var url = replaceParamVal(UrlList.userManagementUrls.validateEmail, {
    email: email
  });
  return apiService.get(url, email, _objectSpread(_objectSpread({}, opts), {}, {
    overrideBaseURL: overrideBaseURL
  }));
};
export var validateGenericEmailApi = function validateGenericEmailApi(email, opts) {
  var overrideBaseURL = UrlList.overrideBaseURL;
  var url = replaceParamVal(UrlList.userManagementUrls.validateGenericEmail, {
    email: email
  });
  return apiService.get(url, email, _objectSpread(_objectSpread({}, opts), {}, {
    overrideBaseURL: overrideBaseURL
  }));
};
export var validatePasswordApi = function validatePasswordApi(password) {
  var url = replaceParamVal(UrlList.userManagementUrls.validatePassword, {
    password: password
  });
  return apiService.post(url, {
    password: password
  });
};
export var getPlantApi = function getPlantApi() {
  return apiService.get(UrlList.plantManagementUrls.getPlant, {}, {
    catchError: true
  });
};
export var getSubscriptionKeyApi = function getSubscriptionKeyApi() {
  return apiService.get(UrlList.plantManagementUrls.getSubscriptionKey, {}, {
    catchError: true
  });
};
export var addPlantApi = function addPlantApi(data, opts) {
  return apiService.post(UrlList.plantManagementUrls.addPlant, data, opts);
};
export var updatePlantApi = function updatePlantApi(data, opts) {
  return apiService.put(UrlList.plantManagementUrls.updatePlant, data, opts);
};
export var deletePlantApi = function deletePlantApi(ObjectID, opts) {
  var url = replaceParamVal(UrlList.plantManagementUrls.deletePlant, {
    ObjectID: ObjectID
  });
  return apiService.delete(url, {}, opts);
};
export var getUserSolutionsApi = function getUserSolutionsApi() {
  return apiService.get(UrlList.solutionUrls.getUserSolutions, {}, {
    catchError: true
  });
};
export var getUserAssignedSolutionsApi = function getUserAssignedSolutionsApi() {
  return apiService.get(UrlList.userManagementUrls.getUserAssignedSolutions, {}, {
    catchError: true
  });
};
export var inviteUserApi = function inviteUserApi(data, opts) {
  var overrideBaseURL = UrlList.overrideBaseURL;
  return apiService.post(UrlList.userManagementUrls.inviteUser, data, _objectSpread(_objectSpread({}, opts), {}, {
    overrideBaseURL: overrideBaseURL
  }));
};
export var validInviteUserEmailApi = function validInviteUserEmailApi(params, opts) {
  var email = params.email,
      status = params.status;
  var url = replaceParamVal(UrlList.userManagementUrls.validInviteUserEmail, {
    email: email,
    status: status
  });
  var overrideBaseURL = UrlList.overrideBaseURL;
  return apiService.get(url, params, _objectSpread(_objectSpread({}, opts), {}, {
    overrideBaseURL: overrideBaseURL
  }));
};
export var getUserRequest = function getUserRequest() {
  var overrideBaseURL = UrlList.overrideBaseURL;
  return apiService.get(UrlList.userManagementUrls.getUserRequest, null, {
    overrideBaseURL: overrideBaseURL,
    catchError: true
  });
};
export var refreshUserRequest = function refreshUserRequest(data) {
  var overrideBaseURL = UrlList.overrideBaseURL;
  return apiService.post(UrlList.userManagementUrls.refreshUserRequest, data, {
    overrideBaseURL: overrideBaseURL,
    catchError: true
  });
};
export var approveUserRequest = function approveUserRequest(data) {
  var overrideBaseURL = UrlList.overrideBaseURL;
  return apiService.put(UrlList.userManagementUrls.approveUserRequest, data, {
    overrideBaseURL: overrideBaseURL,
    catchError: true
  });
};
export var rejectUserRequest = function rejectUserRequest(data) {
  var overrideBaseURL = UrlList.overrideBaseURL;
  return apiService.put(UrlList.userManagementUrls.rejectUserRequest, data, {
    overrideBaseURL: overrideBaseURL,
    catchError: true
  });
};